class DespatchCountdownTimer {
	constructor() {
		this.timerElement_attr = "[variant-countdown-timer]",
		this.same_day_text_attr = "[same-day-despatch]",
		this.next_day_text_attr = "[next-day-despatch]",
		this.weekend_text_attr = "[weekend-despatch]",
		this.tuesday_text_attr = "[tuesday-despatch]",
		this.cut_off_time_attr = "data-cut-off",
		this.holiday_dates_attr = "data-holidays",
		this.time_element = "[time]",
		this.init();
	}

	init() {
		document.addEventListener('DOMContentLoaded', () => {
			// Get elements
			this.timerElement = document.querySelector(this.timerElement_attr);
			if (!this.timerElement) return;

			this.same_day_text_el = this.timerElement.querySelector(this.same_day_text_attr);
			this.next_day_text_el = this.timerElement.querySelector(this.next_day_text_attr);
			this.weekend_text_el = this.timerElement.querySelector(this.weekend_text_attr);
			this.tuesday_text_el = this.timerElement.querySelector(this.tuesday_text_attr);
			this.time_el = this.timerElement.querySelector(this.time_element);

			// Get attributes
			this.cut_off_time = this.timerElement.getAttribute(this.cut_off_time_attr);
			this.holiday_dates = this.timerElement.getAttribute(this.holiday_dates_attr);
			this.holidays = this.holiday_dates ? this.holiday_dates.split(',').map(dateStr => new Date(dateStr.trim()).toDateString()) : [];
			this.targetHour = parseInt(this.cut_off_time, 10);

			if (isNaN(this.targetHour)) {
				console.error("Invalid cut-off time.");
				return;
			}

			this.checkTime();
			this.interval = setInterval(this.checkTime.bind(this), 1000);
		});
	}

	checkTime() {
		const now = new Date();
		const current_day = now.getDay();
	
		const target = new Date();
		target.setHours(this.targetHour, 0, 0, 0);
	
		if (now >= target) {
			target.setDate(target.getDate() + 1);
		}
	
		const timeDifference = target - now;
		const hours = Math.floor(timeDifference / (1000 * 60 * 60));
		const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
	
		const timer = `${hours}h | ${minutes}m | ${seconds}s`;
	
		this.displayText('same_day');
	
		// Check if tomorrow is a holiday
		const tomorrow = new Date(now);
		tomorrow.setDate(tomorrow.getDate() + 1);
	
		// Check if tomorrow is a weekend
		const isWeekendTomorrow = tomorrow.getDay() === 6 || tomorrow.getDay() === 0;
	
		// If it's past the cut-off time
		if (now.getHours() >= this.targetHour) {
			// If today is Friday
			if (current_day === 5) {
				// Check if Monday is a holiday
				const nextMonday = new Date(now);
				nextMonday.setDate(now.getDate() + (8 - current_day)); // get next Monday's date
				if (this.holidays.includes(tomorrow.toDateString())) {
					// If tomorrow (Saturday) is a holiday
					this.displayText('next_day');
				} else if (this.holidays.includes(nextMonday.toDateString())) {
					// If next Monday is a holiday
					this.displayText('tuesday'); // Consider next working day (Tuesday)
				} else {
					this.displayText('weekend'); // Regular weekend delay
				}
			} else {
				// For other days, check if tomorrow is a holiday or weekend
				if (this.holidays.includes(tomorrow.toDateString())) {
					this.displayText('next_day');
				} else if (isWeekendTomorrow) {
					this.displayText('weekend');
				} else {
					this.displayText('next_day');
				}
			}
		}
	
		// If today is Saturday or Sunday
		if (current_day === 6 || current_day === 0) {
			this.displayText('weekend');
		}
	
		// If today is a holiday
		if (this.holidays.includes(now.toDateString())) {
			if (isWeekendTomorrow) {
				this.displayText('weekend');
			} else {
				this.displayText('next_day');
			}
		}
	
		this.time_el.innerHTML = timer;
	}

	displayText(status) {
		const text_statuses = this.timerElement.querySelectorAll('.status');
		if (text_statuses.length > 0) {
			text_statuses.forEach((el) => {
				el.classList.add('hidden');
				el.setAttribute('aria-hidden', 'true');
			});
		}
		switch (status) {
			case 'same_day':
				this.same_day_text_el.classList.remove('hidden');
				this.same_day_text_el.setAttribute('aria-hidden', 'false');
				break;
			case 'next_day':
				this.next_day_text_el.classList.remove('hidden');
				this.next_day_text_el.setAttribute('aria-hidden', 'false');
				break;
			case 'weekend':
				this.weekend_text_el.classList.remove('hidden');
				this.weekend_text_el.setAttribute('aria-hidden', 'false');
				break;
			case 'tuesday':
				this.tuesday_text_el.classList.remove('hidden');
				this.tuesday_text_el.setAttribute('aria-hidden', 'false');
				break;
		}
	}
}

new DespatchCountdownTimer();